module.exports = __webpack_public_path__ + "img/hai.5273d189.svg";